/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
// import moment from "moment";
// import ScrollMenu from "react-horizontal-scrolling-menu";
import parse from 'html-react-parser';

import InfoLeftTab1 from './InfoLeftTab1';
import InfoLeftTab2 from './InfoLeftTab2';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class InfoLeft extends Component {
  state = {
    menuIndex: 0,
    goodCount: 0,
    goodSerial: 0,
  };
  componentDidMount = () => {
    const { contentSerial } = this.props.childProps;
    this._getZzim(contentSerial);
    this._getAlram(contentSerial);
    this._getGoodCount();
  };
  _changeMenu = (menuIndex) => {
    this.setState({
      menuIndex,
    });
  };
  _getAlram = async (contentSerial) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getAlramApi(contentSerial);
      if (result) {
        const intReturn = result.data[0].intReturn;

        this.setState({
          alram: intReturn,
        });
      }
    }
  };
  _getAlramApi = (contentSerial) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem("at");
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/contentAlram',
        {
          params: {
            userid: loginId,
            contentSerial: contentSerial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1, contentSerial);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _getZzim = async (contentSerial) => {
    const { loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getZzimApi(contentSerial);
      if (result) {
        const intReturn = result.data[0].intReturn;

        //console.log(intReturn)

        this.setState({
          zzim: intReturn,
        });
      }
    }
  };
  _getZzimApi = (contentSerial) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    //console.log('/contentZzim/'+contentSerial+ '/'+ loginId)
    return axios
      .post(
        apiUrl + '/contentZzim',
        {
          params: {
            userid: loginId,
            contentSerial: contentSerial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0, contentSerial);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun, contentSerial) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._getZzimApi(contentSerial);
      } else if (gubun === 1) {
        this._getAlram(contentSerial);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _toggleWish = async () => {
    // const { contentSerial } = this.props.childProps;
    const { loginId } = this.props;

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      const result = await this._toggleWishApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        zzim: intReturn,
      });
      if (intReturn === 100) {
        toast.success('찜하기 성공~!');
      } else {
        toast.warn('찜하기 해제~!');
      }
    }
  };
  _toggleWishApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/wishToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };

  _toggleAlram = async () => {
    const { loginId } = this.props;
    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      const result = await this._toggleAlramApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        alram: intReturn,
      });
      if (intReturn === 100) {
        toast.success(
          '알림 등록 성공~! 모바일 APP을 통해서만 받으실 수 있습니다.'
        );
      } else {
        toast.warn('알림 해제 성공~!');
      }
    }
  };
  _toggleAlramApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/alramToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };

  _getGoodCount = async () => {
    const { contentSerial } = this.props.childProps;
    //console.log(contentSerial)
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
    } else {
      const result = await this._getGoodCountApi();
      const intReturn = result.data[0].intReturn;
      //console.log(result)
      if (intReturn === 0) {
        this.setState({
          goodCount: result.data[0].listData[0].cnt,
          goodSerial: result.data[0].listData[0].goodSerial,
        });
      } else {
        this.setState({
          goodCount: 0,
          goodSerial: 0,
        });
      }
    }
  };
  _getGoodCountApi = () => {
    const { apiUrl } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios.post(apiUrl + '/goodCount', {
      params: {
        contentSerial: contentSerial,
      },
    });
  };
  onItem = () => {
    const { history } = this.props;
    const { contentSerial } = this.props.childProps;

    history.push('/items/' + contentSerial);

    //setContentSerial(contentSerial)
  };
  _goods = (goodSerial) => {
    if (goodSerial === 0) {
      toast.warn('관련된 상품이 존재하지 않습니다.');
    } else {
      window.open('https://shop.aniplustv.com/list/A?i=' + goodSerial, '', '');
    }
    //alert(0)
  };
  render() {
    const { menuIndex, zzim, alram, goodCount, goodSerial } = this.state;
    const {
      contentSerial,
      img,
      title,
      subTitle,
      contentSysnopsis,
      timeLineList,
      outputStart,
      outputEnd,
      ratio,
      gubun,
    } = this.props.childProps;
    //console.log(timeLineList)

    return (
      <div className="live_info">
        <div className="live_head">
          <ul className="detailInfo">
            <li className="thumb">
              <div className="badge">
                <img
                  src={
                    gubun === 'D'
                      ? '/img/live_img/badge_new.png'
                      : '/img/live_img/badge_re.png'
                  }
                  alt="첫방"
                />
              </div>
              <img
                src={img}
                onClick={this.onItem}
                style={{ cursor: 'pointer' }}
              />
            </li>
            <li className="info">
              <p
                className="subject"
                onClick={this.onItem}
                style={{ cursor: 'pointer' }}
              >
                {title}
              </p>
              <p
                className="detail"
                onClick={this.onItem}
                style={{ cursor: 'pointer' }}
              >
                {subTitle}
              </p>
              <p className="story">
                {contentSysnopsis ? parse(contentSysnopsis) : null}
              </p>
            </li>
          </ul>
          <div className="btn_wrap">
            <button
              type="button"
              className={zzim === 100 ? 'btn_ico active' : 'btn_ico'}
              onClick={this._toggleWish}
            >
              <i className="ico_like"></i>찜하기
            </button>
            <button
              type="button"
              className={alram === 100 ? 'btn_ico active' : 'btn_ico'}
              onClick={this._toggleAlram}
            >
              <i className="ico_alram"></i>본방알림
            </button>
            <button
              type="button"
              className={goodCount > 0 ? 'btn_ico active' : 'btn_ico'}
              onClick={() => this._goods(goodSerial)}
            >
              <i className="ico_box"></i>상품<span>({goodCount})</span>
            </button>
          </div>
        </div>

        <div className="live_body">
          <ul className="live_menu">
            <li
              onClick={() => this._changeMenu(0)}
              className={menuIndex === 0 ? 'active' : null}
            >
              LIVE 편성정보
            </li>
            <li
              onClick={() => this._changeMenu(1)}
              className={menuIndex === 1 ? 'active' : null}
            >
              LIVE 방영정보
            </li>
          </ul>

          {menuIndex === 0 ? (
            <InfoLeftTab1
              timeLineList={timeLineList}
              title={title}
              subTitle={subTitle}
              outputStart={outputStart}
              outputEnd={outputEnd}
              ratio={ratio}
            />
          ) : (
            <InfoLeftTab2 contentSerial={contentSerial} />
          )}
        </div>
      </div>
    );
  }
}

export default shopContext(withRouter(InfoLeft));
